<template>
    <v-card class="custom-dailog asset-info-dialog">
        <v-card-title>
            {{establishmentData.name}}
            <v-icon class="fas fa-times" data-qe-id="editBusinessInformation_closeBtn1" @click="closeDialog()"></v-icon>
        </v-card-title>
        <v-card-text class="inner-scrollbar text-xs-center">
            <v-flex pb-3>
                <v-flex v-if="establishmentData.brand">
                    {{establishmentData.brand}}
                </v-flex>
                <v-flex v-if="establishmentData.address1">
                    {{establishmentData.address1}}
                </v-flex>
                <v-flex>
                    {{establishmentData.city}}{{getState(establishmentData.state)}}{{getCountry(establishmentData.country)}}
                </v-flex>
            </v-flex>
            <v-flex pb-2 v-if="establishmentData.region">
                <strong>{{businessesInformationConst.REGION}}</strong> {{establishmentData.region}}
            </v-flex>
            <v-flex v-if="establishmentData.establishmentType" pb-2>
                <strong>{{businessesInformationConst.ESTABLISHMENT_TYPE}} </strong> {{establishmentData.establishmentType}}
            </v-flex>
            <v-flex v-if="establishmentData.establishmentType === businessesInformationConst.ACCOMMODATION && establishmentData.accommodationType" pb-2>
                <strong>{{businessesInformationConst.ACCOMMODATION_TYPE}}</strong> {{establishmentData.accommodationType}}
            </v-flex>
            <v-flex v-if="establishmentData.establishmentType === businessesInformationConst.DINING" pb-2>
                <v-flex pb-2 v-if="establishmentData.cuisineType"><strong>{{businessesInformationConst.CUISINE_TYPE}}</strong> {{establishmentData.cuisineType}}</v-flex>
                <v-flex pb-2 v-if="establishmentData.destinationRestaurant"><strong>{{businessesInformationConst.DESTINATION_RESTAURANT}}</strong> {{establishmentData.destinationRestaurant ? "Yes" : "No"}}</v-flex>
                <v-flex pb-2 v-if="establishmentData.otherCategory">{{establishmentData.otherCategory}}</v-flex>
            </v-flex>
            <v-flex v-if="establishmentData.priceRange" pb-2>
                <strong>{{businessesInformationConst.PRICE}}</strong> {{establishmentData.priceRange}}
            </v-flex>
            <v-flex v-if="establishmentData.establishmentType === businessesInformationConst.ACCOMMODATION && establishmentData.hotelClassType" pb-2>
                <strong>{{businessesInformationConst.HOTEL_CLASS_TYPE}}</strong> {{establishmentData.hotelClassType}}
            </v-flex>
            <v-flex v-if="establishmentData.websiteUrl" pb-2>
                <strong>{{businessesInformationConst.WEBSITE_URL}}</strong>
                <a :href="normalizeUrl(establishmentData.websiteUrl)" target="_blank" data-qe-id="business_dialog_websiteurl"> {{establishmentData.websiteUrl}}</a>
            </v-flex>
            <v-flex v-if="establishmentData.discountCode" pb-2>
                <strong>{{businessesInformationConst.DISCOUNT_CODE}}</strong> {{establishmentData.discountCode}}
            </v-flex>
            <v-flex v-if="establishmentData.telephone" pb-2>
                <strong>{{businessesInformationConst.TELEPHONE}}</strong> {{displayTelephone()}}
            </v-flex>
            <v-flex v-if="establishmentData.pointOfContact" pb-2>
                <strong>{{businessesInformationConst.CONTACT_NAME}}</strong> {{establishmentData.pointOfContact}}
            </v-flex>
            <v-flex v-if="establishmentData.pointOfContactTelephone" pb-2>
                <strong>{{businessesInformationConst.CONTACT_PHONE_NUMBER}}</strong> {{displayManagerTelephone()}}
            </v-flex>
            <v-flex v-if="establishmentData.pointOfContactEmail" pb-2>
                <strong>{{businessesInformationConst.CONTACT_EMAIL}}</strong> {{establishmentData.pointOfContactEmail}}
            </v-flex>
            <v-flex v-if="members.length > 0">
                <v-layout row wrap>
                    <v-flex xs12 text-xs-center>
                        <strong>{{businessesInformationConst.MEMBERS}}</strong>
                    </v-flex>
                    <v-flex xs12 align-center>
                        <v-flex class="add-owner__body" v-if="members.length > 0">
                            <v-flex class="add-owner__body__list-item" v-for="(user,i) in members" :key="i">
                                <v-avatar class="add-owner__body__list-item__avatar">
                                    <v-img class="dialog-box__img-format" align-center
                                        :src="user.profileImageUrl"
                                        :alt="user.name"
                                        @click="openMemberProfile(user.personId)"
                                        @error="user.profileImageUrl = user.fallbackProfileImageUrl"
                                        data-qe-id="businessInfo_profileImage">
                                    </v-img>
                                </v-avatar>
                                <v-flex tag="strong" text-xs-left class="add-owner__body__list-item__name">
                                    <span data-qe-id="businessInfo_personname" @click="openMemberProfile(user.personId)">{{user.name}} </span>
                                    <small>{{user.relationshipToAsset}}</small>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-card-text>
    </v-card>
</template>

<script>
    import { businessesInformationConst } from '../Businesses/businesses.constants';
    import { normalizeUrl } from '@/common/utils/utils';
    import { mapActions } from 'vuex';
    import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";
    import { storeAction } from '../../store/storeActions.constant';
    import orderBy from "lodash/orderBy";

    export default {
        name: "BusinessesInformation",
        data() {
            return {
                businessesInformationConst,
                normalizeUrl,
                communityCommonConstant,
            };
        },
        props: {
            establishmentData: {
                type: Object,
                required: true,
            },
            closeDialog: {
                type: Function,
                required: true,
            },
        },
        methods: {
            ...mapActions({
                handleLaunchOfMemberProfile: `memberProfile/${storeAction.handleLaunchOfMemberProfile}`,
            }),
            orderBy,
            getState(state) {
                return state ? `, ${state}` : '';
            },
            getCountry(country) {
                return country ? `, ${country}` : '';
            },
            concateName(first, last) {
                return `${first} ${last}`.toLowerCase();
            },
            displayTelephone() {
                return this.establishmentData.telephoneCountryCode !== null ?
                    `+${this.establishmentData.telephoneCountryCode} ${this.establishmentData.telephone}` :
                    this.establishmentData.telephone;
            },
            displayManagerTelephone() {
                return this.establishmentData.pointOfContactTelephoneCountryCode !== null ?
                    `+${this.establishmentData.pointOfContactTelephoneCountryCode} ${this.establishmentData.pointOfContactTelephone}` :
                    this.establishmentData.pointOfContactTelephone;
            },
            openMemberProfile(personId) {
                this.handleLaunchOfMemberProfile({
                    memberId: personId,
                    name: this.getCommunityInfo && !this.$route.name.includes('home') ? this.getCommunityInfo.name : this.communityCommonConstant.AROUND_ME,
                    router: this.$router,
                });
            },
        },
        computed: {
            members() {
                return (this.establishmentData && this.establishmentData.personAssetRelation) ?
                orderBy(this.establishmentData.personAssetRelation.filter(x => x.isActive === true), [item => this.concateName(item.firstName, item.lastName)], "asc") :
                [];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .add-owner {
        z-index: 1;
        position: absolute;
        left: 40px;
        top: 35px;
        width: 100%;

        &__body {
            max-height: 350px;
            padding: 0px 15px 0px 15px;
            overflow-y: auto;

            &__list-item {
                position: relative;
                padding: 13px 38px 10px 130px;
                align-items: center;
                min-height: 60px;
                display: inline-block;
                width: 100%;

            &__avatar {
                position: absolute;
                left: -1px;
                top: 5px;
                padding-left: 100px;
                cursor: pointer;
                    img {
                        height: 40px;
                        width: 40px;
                    }
                }

                &__name {
                    font-size: 12px;
                    font-weight: 600;
                    display: block;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;

                    span {
                        cursor: pointer;
                    }
                }

                small {
                    display: block;
                }
            }
        }
    }
</style>
